<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <div
            v-if="!businessListings || businessListings.length === 0"
            class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-info fade show mt-4 mb-1"
            role="alert"
          >
            <div class="m-alert__icon">
              <i class="flaticon-danger" />
              <span />
            </div>
            <div class="m-alert__text">
              <strong>{{ $t( 'Directory.form.Attention' ) }}:</strong> {{ $t( 'Directory.noneFound' ) }}
            </div>
          </div>

          <!-- Begin::List -->
          <div
            v-if="businessListings && businessListings.length > 0"
            id="directoryEnquirieList"
            class="row"
          >
            <div class="col-xl-12">
              <!--Begin::Portlet-->

              <div
                class="m-portlet m-portlet--rounded m-portlet--head-sm fullable-portlet"
                :m-portlet="'true'"
              >
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                        <i class="flaticon-mail m--font-brand m--icon-font-size-lg2 mt-n1" />
                      </span>
                      <h3 class="m-portlet__head-text">
                        {{ heading }}
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">
                      <li class="m-portlet__nav-item">
                        <a
                          href="javascript:"
                          :m-portlet-tool="'fullscreen'"
                          data-trigger="hover"
                          class="m-portlet__nav-link m-portlet__nav-link--icon"
                        ><i class="la la-expand" /></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="m-portlet__body">
                  <!--Begin::Search-->
                  <div class="row">
                    <div class="col-xl-12">
                      <form
                        action=""
                        @submit.prevent="startSearch"
                      >
                        <div class="row">
                          <div class="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-3 form-group">
                            <div class="form_group">
                              <div class="m-form_label">
                                <label>{{ $t('Property.Enquiries.DateFrom') }}:</label>
                              </div>
                              <input
                                id="FromDate"
                                v-model="params.FromDate"
                                min="2016-04-01"
                                required
                                name="FromDate"
                                class="form-control m-input m-input--solid"
                                type="date"
                              >
                            </div>
                            <div class="d-lg-none m--margin-bottom-10" />
                          </div>

                          <div class="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-3 form-group">
                            <div class="form_group">
                              <div class="m-form_label">
                                <label>{{ $t('Property.Enquiries.DateTo') }}:</label>
                              </div>

                              <input
                                id="ToDate"
                                v-model="params.ToDate"
                                :max="maxDayToday"
                                name="ToDate"
                                class="form-control m-input m-input--solid "
                                type="date"
                              >
                            </div>
                            <div class="d-lg-none m--margin-bottom-10" />
                          </div>

                          <div class="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-6 form-group pt-xl-4 pt-lg-0 pt-md-0 pt-sm-0 pt-0 mt-2">
                            <button
                              type="submit"
                              class="btn btn-sm btn-brand m-btn m-btn--custom m-btn--icon mt-1 btn-sm-block"
                            >
                              <span>
                                <i class="la la-search" />
                                <span>{{ $t('common.ApplyFilters') }}</span>
                              </span>
                            </button>

                            <button
                              type="button"
                              class="btn btn-sm btn-danger m-btn m-btn--custom m-btn--icon mt-1 btn-sm-block"
                            >
                              <span>
                                <i class="la la-search-minus" />
                                <span @click="clearForm()">{{ $t('Property.form.Clear') }}</span>
                              </span>
                            </button>

                            <button
                              id="filtersBtn"
                              class="btn btn-sm btn-metal m-btn m-btn--custom m-btn--icon mt-1 btn-sm-block"
                              type="button"
                              role="button"
                              data-toggle="collapse"
                              data-target="#DirectoryEnquiriesSearchFrm"
                              aria-expanded="false"
                              aria-controls="DirectoryEnquiriesSearchFrm"
                            >
                              <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2" />
                              <span
                                id="moreFiltersSpan"
                                class="d-inline moreFiltersSpan"
                              >{{ $t('Property.Analytics.Morefilters') }}</span>
                            </button>
                          </div>
                        </div>

                        <div
                          id="DirectoryEnquiriesSearchFrm"
                          style=""
                          class="m-form collapse"
                        >
                          <div class="m-separator m-separator--dashed mt-2" />

                          <div class="m-form m-form--label-align-right">
                            <div class="row align-items-center">
                              <div class="col-xl-12">
                                <div class="row form-group">
                                  <div class="col-12 col-md-12 col-sm-12 col-lg-2 form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Name') }}:</label>
                                      </div>

                                      <input
                                        v-model="params.Name"
                                        type="text"
                                        name="Name"
                                        class="form-control m-input m-input--solid"
                                        :placeholder="$t('Property.Enquiries.placeholder.name')"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg-2 form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Email') }}:</label>
                                      </div>

                                      <input
                                        v-model="params.Email"
                                        type="text"
                                        name="Email"
                                        class="form-control m-input m-input--solid"
                                        :placeholder="$t('Property.Enquiries.placeholder.email-v2')"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg-2 form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Telephone') }}:</label>
                                      </div>

                                      <input
                                        v-model="params.Phone"
                                        type="text"
                                        name="Phone"
                                        class="form-control m-input m-input--solid"
                                        :placeholder="$t('Property.Enquiries.placeholder.phone')"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg-2 form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Type') }}:</label>
                                      </div>
                                      <select
                                        v-model="params.Type"
                                        :value="params.Type"
                                        class="custom-select form-control m-input--solid"
                                      >
                                        <option value="all">
                                          {{ $t('Property.Enquiries.AllEnquiries') }}
                                        </option>
                                        <option value="web">
                                          {{ $t('Property.Enquiries.ContactFormEnquiries') }}
                                        </option>
                                        <option value="phone">
                                          {{ $t('Property.Enquiries.TelephoneEnquiries') }}
                                        </option>
                                      </select>
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                  <div class="col-12 col-md-12 col-sm-12 col-lg-4 form-group">
                                    <div class="form_group">
                                      <div class="m-form_label">
                                        <label>{{ $t('Property.Enquiries.Message') }}:</label>
                                      </div>
                                      <input
                                        v-model="params.Comment"
                                        type="text"
                                        name="Comment"
                                        :placeholder="$t('Property.Enquiries.Message')"
                                        class="form-control m-input m-input--solid"
                                      >
                                    </div>
                                    <div class="d-lg-none m--margin-bottom-10" />
                                  </div>
                                </div>

                                <div class="row form-group">
                                  <div class="col-12 col-md-12 col-sm-12 col-lg form-group">
                                    <div class="form_group">
                                      <button
                                        type="submit"
                                        class="btn-sm btn btn-brand btn-sm font-weight-light m--font-light btn m-btn m-btn--custom m-btn--icon btn-xs-block"
                                      >
                                        <span>
                                          <i class="la la-search" />
                                          <span>{{ $t('common.ApplyFilters') }}</span>
                                        </span>
                                      </button>
                                      <button
                                        type="button"
                                        class="btn-sm btn btn-danger btn-sm font-weight-light m--font-light btn m-btn m-btn--custom m-btn--icon btn-xs-block"
                                      >
                                        <span>
                                          <i class="la la-search-minus" />
                                          <span @click="clearForm()">{{ $t('Property.form.Clear') }}</span>
                                        </span>
                                      </button>
                                      <a
                                        class="btn-sm font-weight-light m--font-light btn btn-metal m-btn m-btn--custom m-btn--icon btn-xs-block"
                                        data-toggle="collapse"
                                        data-keyboard="false"
                                        href="#DirectoryEnquiriesSearchFrm"
                                        aria-controls="DirectoryEnquiriesSearchFrm"
                                      >
                                        <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2" />
                                        <span class="d-inline moreFiltersSpan">{{ $t('Property.Analytics.Hidefilters') }}</span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="m-separator m-separator--dashed mt-2" />
                      </form>
                    </div>
                  </div>
                  <!--End::Search-->

                  <!--Begin::Table-->
                  <div class="row">
                    <div class="col-xl-12 mb-3">
                      <div class="pull-left">
                        {{ $t('Property.table.Records') }}:

                        <span v-if="enquiries.length === 0">{{ $t('Property.table.NoRecordsFound') }}</span>
                        <span v-else-if="enquiries.length > 0 && pagination.total <= recordTo">{{ recordFrom }} {{ $t('Property.table.To') }} {{ recordTo }}</span>
                        <span v-else>{{ recordFrom }} {{ $t('Property.table.To') }} {{ recordTo }} {{ $t('Property.table.From') }}  {{ pagination.total }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="table_sticky-header">
                    <table
                      id="tableDirectoriesEnquiries"
                      class="table m-table m-table--head-no-border table table-striped"
                    >
                      <thead class="showMobile">
                        <tr class="">
                          <th
                            style="width:auto;"
                            class="align-middle text-center showMobile"
                          >
                            <div
                              v-if="enquiries.length > 0"
                              class="m-checkbox-inline d-inline pull-left"
                            >
                              <label class="m-checkbox m-checkbox--solid m-checkbox--brand pb-1">
                                <input
                                  id="checkAll"
                                  type="checkbox"
                                  :checked="allSelected"
                                  @change="selectAll"
                                >
                                <span />
                              </label>
                            </div>

                            <div
                              v-if="(selectedEnquiries.length > 0)"
                              id="dropDownActions"
                              class="pull-left m-dropdown m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-left m-dropdown--mobile-full-width d-inline"
                            >
                              <dropdown
                                btn-class="m-dropdown__toggle btn btn-xs btn-outline-brand dropdown-toggle m--regular-font-size-sm2"
                              >
                                <template #btn>
                                  {{ $t('Property.table.actions') }}
                                </template>
                                <template #dropdown>
                                  <span class="m-dropdown__arrow m-dropdown__arrow--left text-white" />
                                  <div class="m-dropdown__inner">
                                    <div class="m-dropdown__body">
                                      <div class="m-dropdown__content">
                                        <ul class="m-nav m-nav--skin-light text-center">
                                          <li class="m-nav__item">
                                            <label for="AgentEmailResend">{{ $t('Property.Enquiries.Resend') }}</label>
                                            <input
                                              id="AgentEmailResend"
                                              v-model="agentEmail"
                                              required
                                              type="email"
                                              class="form-control form-control-sm m-input m-input--solid mb-2"
                                              placeholder="forward@email.to"
                                            >
                                            <button
                                              class="btn btn-sm btn-brand"
                                              @click="resendEmail"
                                            >
                                              {{ $t('Property.Enquiries.ResendSelectedEmails') }}
                                            </button>
                                            <div class="separata mt-4" />
                                          </li>
                                          <li class="m-nav__item mt-3">
                                            <label>{{ $t('Property.Enquiries.Report') }}</label>
                                            <button
                                              class="btn btn-sm btn-info btn-block"
                                              @click="reportSpam"
                                            >
                                              {{ $t('Property.Enquiries.Spam') }}
                                            </button>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </dropdown>
                            </div>
                          </th>
                          <th
                            style="width:15%;"
                            class="text-left"
                          >
                            {{ $t('Property.Enquiries.Date') }}<small> / </small>{{ $t('Directory.Enquiries.Table.header.Outlet') }}
                          </th>
                          <th
                            style="width:20%;"
                            class="text-left"
                          >
                            {{ $t('Property.Enquiries.From') }}
                          </th>
                          <th
                            style="width:auto;"
                            class="text-left"
                          >
                            {{ $t('Property.Enquiries.Language') }}<small>
                              / </small>{{ $t('Property.Enquiries.Location') }}
                          </th>
                          <th
                            style="width:35%;"
                            class="text-left"
                          >
                            {{ $t('Property.Enquiries.Message') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="directoryEnquiryList !== null">
                        <tr
                          v-for="(enquiry, index) in enquiries"
                          :key="index"
                          :class="getSpamColor(enquiry)"
                        >
                          <td
                            class="align-middle"
                            data-thead-name=""
                          >
                            <div class="m-checkbox-inline-block">
                              <label class="m-checkbox m-checkbox--solid m-checkbox--brand">
                                <input
                                  v-model="selectedEnquiries"
                                  type="checkbox"
                                  :value="enquiry"
                                >
                                <span>
                                  <span v-if="enquiry.Type === 'iovox-call'">
                                    <i class="la la-phone la-phone-valign" />
                                    <template v-if="enquiry.Data.Destination.toLowerCase() !== 'not applicable'">
                                      +{{ enquiry.Data.Destination }}
                                    </template>
                                    <template v-else>
                                      {{ $t("calls.outOfHours") }}
                                    </template>
                                  </span>
                                </span>
                              </label>
                            </div>
                          </td>

                          <td
                            class="align-middle"
                            :data-thead-name="$t('Property.Enquiries.Date')+' / '+$t('Directory.Enquiries.Table.header.Outlet') "
                          >
                            <template v-if="enquiry.Type === 'iovox-call'">
                              {{ formatDate( enquiry.Data.Start ) }}
                            </template>
                            <template v-else>
                              {{ formatDate( enquiry.Data.SendDate ) }}
                            </template>
                            <br>
                            <div style="max-width: 280px !important;">
                              <div class="text-truncate">
                                <a
                                  :href="enquiry.Data.EnquiryURL"
                                  target="_blank"
                                >{{ enquiry.Data.Interest }}</a>
                              </div>
                            </div>
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="$t('Property.Enquiries.From')"
                          >
                            <template v-if="enquiry.Data.Email">
                              <p class="mb-1">
                                {{ enquiry.Data.Name }}
                              </p>
                              <p class="mb-1">
                                <a :href="`mailto:${enquiry.Data.Email}`">{{ enquiry.Data.Email }}</a>
                              </p>
                              <p
                                v-if="enquiry.Data.Phone"
                                class="m-0"
                              >
                                <a :href="`tel:${formatTel(enquiry.Data.Phone)}`">{{ enquiry.Data.Phone }}</a>
                              </p>
                            </template>
                            <template v-else>
                              +{{ enquiry.Data.Origin }}
                            </template>
                          </td>
                          <td
                            class="align-middle"
                            :data-thead-name="$t('Property.Enquiries.Language')+' / '+$t('Property.Enquiries.Location')"
                          >
                            <img
                              v-if="enquiry.Data.Language"
                              alt=""
                              width="25px"
                              class="m--hidden-tablet-and-mobile"
                              :src="cdnURL+'/img/flags/'+ getFlag(enquiry.Data.Language.toLowerCase())+'.png'"
                            >

                            <span v-if="enquiry.Data.Language">{{ enquiry.Data.Language.toUpperCase() }}</span><br>
                            <i
                              v-if="enquiry.Data.Country"
                              class="la la-map-marker m--hidden-tablet-and-mobile"
                            />

                            <span v-if="enquiry.Data.Country">{{ enquiry.Data.Country.toUpperCase() }}</span>

                            <template v-if="enquiry.Data.Start">
                              <i class="la la-map-marker" /> {{ (enquiry.Data.OriginLocation || "").replace(/,(?! )/, ', ') }}
                            </template>
                          </td>
                          <td
                            class="align-middle prewrap"
                            :data-thead-name="$t('Property.Enquiries.Message')"
                          >
                            <template v-if="enquiry.Data.Comment">
                              <span
                                v-if="enquiry.Data.Comment.length <= 280"
                                class="comment"
                              >
                                {{ enquiry.Data.Comment }}
                              </span>
                              <span v-else>
                                <span class="comment">
                                  {{ shortDescription(enquiry.Data.Comment) }}
                                </span>
                                <a
                                  href="javascript:"
                                  :data-ts-full-desc="enquiry.Data.Comment"
                                  :data-ts-short-desc="shortDescription(enquiry.Data.Comment)"
                                  @click="replaceShortDescByFull"
                                >
                                  <span class="see-more ml-2"> <small>[{{ $t('Property.Enquiries.seeMore') }} +]</small></span>
                                  <span
                                    class="see-less m--hide ml-2"
                                  ><small>[{{ $t('Property.Enquiries.seeLess') }} -]</small></span>
                                </a>
                              </span>
                            </template>
                            <template v-if="enquiry.Data.Result">
                              {{ $t('Property.Enquiries.IOVOX.'+enquiry.Data.Result) }}
                              <span v-if="enquiry.Data.TalkTimeSec > 0">({{ $t('Property.Enquiries.CallTime') }}: {{ formatDuration(enquiry.Data.TalkTimeSec) }})</span>
                            </template>
                          </td>
                        </tr>
                        <tr v-if="enquiries.length === 0">
                          <td
                            colspan="5"
                            class="text-center m--regular-font-size-lg3 py-5"
                          >
                            {{ $t('Property.table.NoRecordsFound') }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="m-separator m-separator--dashed mt-2" />
                  </div>
                  <!--End::Table-->

                  <Pagination
                    :total-pages="pagination.totalPages"
                    :total="pagination.total"
                    :loading="false"
                    :current-page="pagination.currentPage"
                    @pagechanged="onPageChange"
                  />
                </div>
              </div>

              <!--end: Portlet-->
            </div>
          </div>
          <!-- End::List -->
        </div>
      </div>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter />
    <!-- END: Footer -->
  </div>
</template>

<script>
import Pagination from '../../common/Pagination.vue';
import { getUser, onBeforeOpenSwal } from '../../../../functions.ts';
import AppHeader from '../../common/Header.vue';
import AppFooter from '../../common/Footer.vue';
import LeftMenu from '../../common/menus/LeftMenu.vue';
import { clientapi } from '../../../../api-clients/client-api.js';
import dayjs from 'dayjs';
import { businesslistingsapi } from '../../../../api-clients/business-listings-api.js';
import { formatPhoneForTelLink } from '../../../../common/tel.js';
import Dropdown from '../../../Dropdown.vue';

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
        Pagination,
        Dropdown,
    },
    data() {
        return {
            params: {
                Skip: 0,
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().format( 'YYYY-MM-DD' ),
                Ref: null,
                PropertyId: null,
                Name: '',
                Email: '',
                Phone: '',
                Type: 'all',
                Spam: false,
                Comment: '',
            },
            resultsPerPage: 20,
            user: {},
            agentEmail: '',
            searchParams: {},
            pagination: {
                totalPages: 0,
                total: 0,
                currentPage: 1,
            },
            selectedEnquiries: [],
            // table
            cdnURL: import.meta.env.TWC_CDN_URL,
            enquiries: [],
            businessListings: [],
        };
    },
    computed: {
        heading() {
            switch ( this.searchParams.Type ) {
            case 'web': return this.$t( 'Property.Enquiries.ContactFormEnquiries' ) + this.$t( 'Directory.headingSuffix' );
            case 'phone': return this.$t( 'Property.Enquiries.TelephoneEnquiries' ) + this.$t( 'Directory.headingSuffix' );
            }

            return this.$t( 'Property.Enquiries.AllEnquiries' ) + this.$t( 'Directory.headingSuffix' );
        },
        allSelected() {
            return this.selectedEnquiries.length === this.enquiries.length;
        },
        maxDayToday() {
            return dayjs().tz().format( 'YYYY-MM-DD' );
        },
        directoryEnquiryList() {
            return this.enquiries;
        },
        recordFrom() {
            return ( this.resultsPerPage * ( this.pagination.currentPage - 1 ) ) + 1;
        },
        recordTo() {
            return Math.min( this.recordFrom + this.resultsPerPage - 1, this.pagination.total );
        },
    },
    watch: {
        '$route.query': {
            handler: function( newQuery, oldQuery ) {
                this.updateParamsFromRoute();

                if ( !this.businessListings || this.businessListings.length === 0 ) {
                    return;
                }

                this.doSearch();
            },
            immediate: false,
        },
    },
    async created() {
        this.user = getUser();

        this.agentEmail = this.user.Email;

        // if ( this.directoryService && this.directoryService.Outlet && this.directoryService.Outlet.Email ) {
        //   this.agentEmail = this.directoryService.Outlet.Email
        // }

        const params = new URLSearchParams();
        params.set( 'take', 50 );
        params.set( 'agents', this.user.Login );
        params.set( 'includeInactive', true );

        let result = await businesslistingsapi.get( `/listings?${params.toString()}` );

        if ( result.status !== 200 ) {
            swal( {
                title: this.$t( 'error.AnErrorOccurred' ),
                type: 'error',
                confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );
        } else {
            this.businessListings = result.data.results;
        }

        this.updateParamsFromRoute();

        this.doSearch();
        this.setUpHideShowFilters();
    },
    methods: {
        formatTel( v ) {
            return formatPhoneForTelLink( v );
        },
        getDefaultParams() {
            return {
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().format( 'YYYY-MM-DD' ),
                Ref: null,
                PropertyId: null,
                Name: '',
                Email: '',
                Phone: '',
                Type: 'all',
                Spam: false,
                Comment: '',
                Skip: 0,
            };
        },
        updateParamsFromRoute() {
            let defaultParams = this.getDefaultParams();
            this.params.FromDate = this.$route.query.fromdate || defaultParams.FromDate;
            this.params.ToDate = this.$route.query.todate || defaultParams.ToDate;
            this.params.Ref = this.$route.query.ref || defaultParams.Ref;
            this.params.PropertyId = this.$route.query.propertyid || defaultParams.PropertyId;
            this.params.Name = this.$route.query.name || defaultParams.Name;
            this.params.Email = this.$route.query.email || defaultParams.Email;
            this.params.Phone = this.$route.query.phone || defaultParams.Phone;
            this.params.Type = this.$route.query.type || defaultParams.Type;
            this.params.Spam = this.$route.query.spam || defaultParams.Spam;
            this.params.Comment = this.$route.query.comment || defaultParams.Comment;
            this.params.Skip = this.$route.query.skip || defaultParams.Skip;
        },
        updateRouteFromParams() {
            let defaultParams = this.getDefaultParams();

            let newRouteParams = {
                fromdate: this.params.FromDate,
                todate: this.params.ToDate,
            };

            if ( this.params.Ref !== defaultParams.Ref ) {
                newRouteParams.ref = this.params.Ref;
            }

            if ( this.params.PropertyId !== defaultParams.PropertyId ) {
                newRouteParams.propertyid = this.params.PropertyId;
            }

            if ( this.params.Name !== defaultParams.Name ) {
                newRouteParams.name = this.params.Name;
            }

            if ( this.params.Email !== defaultParams.Email ) {
                newRouteParams.email = this.params.Email;
            }

            if ( this.params.Phone !== defaultParams.Phone ) {
                newRouteParams.phone = this.params.Phone;
            }

            if ( this.params.Type !== defaultParams.Type ) {
                newRouteParams.type = this.params.Type;
            }

            if ( this.params.Spam !== defaultParams.Spam ) {
                newRouteParams.spam = this.params.Spam;
            }

            if ( this.params.Comment !== defaultParams.Comment ) {
                newRouteParams.comment = this.params.Comment;
            }

            if ( this.params.Skip !== defaultParams.Skip ) {
                newRouteParams.skip = this.params.Skip;
            }

            if ( JSON.stringify( this.$route.query ) !== JSON.stringify( newRouteParams ) ) {
                this.$router.push( { query: newRouteParams } );
            }
        },
        formatDuration( totalSeconds ) {
            let hours = Math.floor( totalSeconds / 60 / 60 );
            let minutes = Math.floor( totalSeconds / 60 - ( hours * 60 ) );
            let seconds = Math.floor( totalSeconds - ( hours * 60 * 60 ) - ( minutes * 60 ) );

	      return `${hours.toString().padStart( 2, '0' )}:${minutes.toString().padStart( 2, '0' )}:${seconds.toString().padStart( 2, '0' )}`;
        },
        selectAll() {
            if ( this.allSelected ) {
                this.selectedEnquiries = [];
                return;
            }
            this.selectedEnquiries = this.enquiries;
        },
        clearForm() {
            this.params = this.getDefaultParams();
        },
        onPageChange( page ) {
            this.params.Skip = ( page - 1 ) * this.resultsPerPage;
            this.selectedEnquiries = [];
            this.updateRouteFromParams();
        },
        setUpHideShowFilters() {
            let vueThis = this;
            let $form = $( '#DirectoryEnquiriesSearchFrm' );
            $form.on( 'hide.bs.collapse', function() {
                document.getElementById( 'moreFiltersSpan' ).innerHTML = vueThis.$t( 'Property.Analytics.MoreFilters' );
            } );
            $form.on( 'show.bs.collapse', function() {
                document.getElementById( 'moreFiltersSpan' ).innerHTML = vueThis.$t( 'Property.Analytics.Hidefilters' );
            } );
        },
        async startSearch() {
            this.params.Skip = 0;
            this.updateRouteFromParams();
        },
        async doSearch() {
            if ( !this.businessListings || this.businessListings.length === 0 ) {
                return;
            }

            this.selectedEnquiries = [];

            this.searchParams = {};
            this.searchParams.Logins = this.user.Login;
            this.searchParams.Spam = false;
            this.searchParams.Deleted = false;
            this.searchParams.Skip = this.params.Skip;
            this.searchParams.Take = this.resultsPerPage;
            this.searchParams.FromDate = dayjs.tz( this.params.FromDate, 'YYYY-MM-DD', 'Europe/Madrid' ).format();
            this.searchParams.ToDate = dayjs.tz( this.params.ToDate, 'YYYY-MM-DD', 'Europe/Madrid' ).endOf( 'day' ).format();

            if ( this.params.Name.length > 0 ) {
                this.searchParams.Name = `%${this.params.Name}%`;
            }

            if ( this.params.Email.length > 0 ) {
                this.searchParams.Email = `%${this.params.Email}%`;
            }

            if ( this.params.Phone.length > 0 ) {
                this.searchParams.Phone = `%${this.params.Phone}%`;
            }

            if ( this.params.Comment.length > 0 ) {
                this.searchParams.Comment = `%${this.params.Comment}%`;
            }

            if ( this.params.Type.length > 0 && this.params.Type !== 'all' ) {
                this.searchParams.Type = this.params.Type;
            }

            await this.doSearchFromSearchParams();
        },
        async doSearchFromSearchParams() {
            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            this.loading = true;

            let params = this.searchParams;

            let contacts = businesslistingsapi.get( '/listings/enquiries/summary', { params: this.searchParams } );

            let countParams = Object.assign( {}, params );

            delete countParams[ 'Take' ];
            delete countParams[ 'Skip' ];

            let stats = businesslistingsapi.get( '/listings/enquiries/count', { params: countParams } );

            contacts = ( await contacts ).data || [];

            const webEnquiryIds = contacts.filter( ( c ) => c.Type === 'web-enquiry' ).map( ( c ) => c.Identifier );
            const iovoxIds = contacts.filter( ( c ) => c.Type === 'iovox-call' ).map( ( c ) => c.Identifier );

            const iovoxCallsFunc = async () => {
                if ( iovoxIds.length === 0 ) {
                    return { status: 200,
                        data: [] };
                }

                return await clientapi.get( '/calls/directory?' + iovoxIds.map( ( el ) => 'Id=' + el ).join( '&' ) );
            };

            const webEnquiryFunc = async () => {
                if ( webEnquiryIds.length === 0 ) {
                    return { status: 200,
                        data: [] };
                }

                return await businesslistingsapi.get( '/listings/enquiries?' + webEnquiryIds.map( ( el ) => 'Id=' + el ).join( '&' ) );
            };

            const iovoxCalls = ( await iovoxCallsFunc() ).data || [];
            const webEnquiries = ( await webEnquiryFunc() ).data || [];

            let allEnquieries = [];

            for ( let enq of contacts ) {
                switch ( enq.Type ) {
                case 'web-enquiry': {
                    const data = webEnquiries.filter( ( e ) => e.Id == enq.Identifier )[ 0 ];
                    allEnquieries.push( { Type: enq.Type,
                        Data: data } );
                    break;
                }
                case 'iovox-call': {
                    const data = iovoxCalls.filter( ( e ) => e.Id == enq.Identifier )[ 0 ];
                    allEnquieries.push( { Type: enq.Type,
                        Data: data } );
                    break;
                }
                }
            }

            let statsResult = await stats;

            if ( statsResult.status === 200 ) {
                this.pagination.total = statsResult.data.count;
                this.pagination.currentPage = Math.ceil( this.searchParams.Skip / this.resultsPerPage ) + 1;
                this.pagination.totalPages = Math.ceil( this.pagination.total / this.searchParams.Take );
            }

            this.enquiries = allEnquieries;

            mApp.unblock( 'body' );
            this.loading = false;
        },
        getSpamColor( enquiry ) {
            if ( enquiry.Type === 'iovox-call' ) {
                return 'isIOVOX';
            }

            let webEnquiry = enquiry.Data;

            if ( webEnquiry.IsSpam ) {
                return 'isSpam';
            }

            if ( !webEnquiry.IsSpam && !webEnquiry.IsSent ) {
                return 'noSpamNoSend';
            }

            return 'noColor';
        },
        replaceShortDescByFull( event ) {
            let target = event.target;
            let comment_cont = target.parentNode.parentNode.parentNode.getElementsByClassName( 'comment' )[ 0 ];
            let full_text = target.parentNode.parentNode.parentNode.querySelectorAll( '[data-ts-full-desc]' )[ 0 ].dataset[ 'tsFullDesc' ];
            let short_text = target.parentNode.parentNode.parentNode.querySelectorAll( '[data-ts-short-desc]' )[ 0 ].dataset[ 'tsShortDesc' ];
            let see_more = target.parentNode.parentNode.parentNode.getElementsByClassName( 'see-more' )[ 0 ];
            let see_less = target.parentNode.parentNode.parentNode.getElementsByClassName( 'see-less' )[ 0 ];

            if ( see_less.classList.contains( 'm--hide' ) ) {
                see_more.classList.add( 'm--hide' );
                see_less.classList.remove( 'm--hide' );
                comment_cont.innerHTML = full_text;
            } else {
                see_less.classList.add( 'm--hide' );
                see_more.classList.remove( 'm--hide' );
                comment_cont.innerHTML = short_text;
            }
        },
        shortDescription( text ) {
            if ( text.length > 280 ) {
                return text.substring( 0, 225 ) + '...';
            }
            return text;
        },
        formatDate( date ) {
            return dayjs( date ).tz().format( 'DD/MM/YYYY H:mm' );
        },
        getFlag( country ) {
            if ( country === 'en' ) {
                return 'gb';
            }
            return country;
        },
        async resendEmail() {
            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            let email = this.agentEmail;

            let send = async ( enq ) => {
                let id = enq.Data.Id;
                if ( enq.Type === 'iovox-call' ) {
                    let result = await clientapi.post( `/calls/directory/${id}/send`, { email: email,
                        language: this.$i18n.locale } );
                    return result.status === 200;
                } else {
                    let result = await clientapi.post( `/directoryenquiries/${id}/resend`, { email: email,
                        language: this.$i18n.locale } );
                    return result.status === 200;
                }
            };

            let promises = [];

            for ( let enq of this.selectedEnquiries ) {
                let localEnq = Object.assign( {}, enq );
                promises.push( send( enq ) );
            }

            let results = await Promise.all( promises );

            mApp.unblock( 'body' );

            let withSuccess = results.filter( ( r ) => r ).length;
            let withError = results.filter( ( r ) => !r ).length;

            if ( !withError ) {
                this.selectedEnquiries = [];
            }

            let title = this.$t( 'Property.Enquiries.TotalEmailSend' );
            let html = '';
            let type = 'info';
            if ( withError > 0 ) {
                html = `<spam class="d-block">${this.$t( 'Property.Enquiries.Failed' )}: <span class="m--font-boldest">${withError}</span></spam>`;
                type = 'warning';
            } else if ( withSuccess > 0 ) {
                html = `<spam class="d-block">${this.$t( 'Property.Enquiries.enquiriesSended' )}: <span class="m--font-boldest">${withSuccess}</span></spam>`;
            }

            swal( {
                title: title,
                html: html,
                showCancelButton: false,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'common.ok' ),
                type: type,
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );
        },
        async reportSpam() {
            let isConfirm = await swal( {
                title: this.$t( 'Property.Enquiries.reportType', { type: 'spam' } ),
                text: this.$t( 'Property.Enquiries.confirmSpam', this.selectedEnquiries.length, { type: 'spam' } ),
                showCancelButton: true,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'Property.Enquiries.yesReportIt' ),
                cancelButtonText: this.$t( 'common.Cancel' ),
                type: 'warning',
                input: 'textarea',
                inputPlaceholder: this.$t( 'Property.Enquiries.spamReasonPlaceholder' ),
                inputValidator: ( value ) => {
                    if ( !value ) {
                        return this.$t( 'Property.Enquiries.spamReasonInvalidField' );
                    }
                },
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );

            if ( isConfirm.dismiss ) {
                return;
            }

            if ( !isConfirm.value ) {
                return;
            }

            let reason = isConfirm.value;

            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            let email = this.agentEmail;

            let send = async ( enq ) => {
                let id = enq.Data.Id;
                if ( enq.Type === 'iovox-call' ) {
                    let result = await clientapi.post( `/calls/directory/${id}/markasspam`, { email: email,
                        reason: reason } );
                    return result.status === 200;
                } else {
                    let result = await clientapi.post( `/directoryenquiries/${id}/markasspam`, { email: email,
                        reason: reason } );
                    return result.status === 200;
                }
            };

            let promises = [];

            for ( let enq of this.selectedEnquiries ) {
                let localEnq = Object.assign( {}, enq );
                promises.push( send( enq ) );
            }

            let results = await Promise.all( promises );

            let withSuccess = results.filter( ( r ) => r ).length;
            let withError = results.filter( ( r ) => !r ).length;

            if ( !withError ) {
                this.selectedEnquiries = [];
            }

            mApp.unblock( 'body' );

            let title = this.$t( 'Property.Enquiries.TotalEmailMarked' );
            let html = '';
            let type = 'info';

            if ( withError > 0 ) {
                html += `<spam class="d-block">${this.$t( 'Property.Enquiries.Failed' )}: <span class="m--font-boldest">${withError}</span></spam>`;
                type = 'warning';
            } else if ( withSuccess > 0 ) {
                html = `<spam class="d-block">${this.$t( 'Property.Enquiries.enquiriesMarked' )}: <span class="m--font-boldest">${withSuccess}</span></spam>`;
            }

            swal( {
                title: title,
                html: html,
                showCancelButton: false,
                confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
                confirmButtonText: this.$t( 'common.ok' ),
                type: type,
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );
        },
    },
};

</script>
